(function(){
var P="https://untappd-proxy.sales-61c.workers.dev/";
function stars(v){
  v=parseFloat(v)||0;
  var f=Math.round(v*2)/2,h="",i;
  for(i=1;i<=5;i++){
    if(i<=f){h=h+'<svg class="ut-star ut-star--full" viewBox="0 0 20 20"><polygon points="10,1 12.9,7 19.5,7.6 14.5,12 16.2,18.5 10,15 3.8,18.5 5.5,12 0.5,7.6 7.1,7"/></svg>';}
    else{h=h+'<svg class="ut-star ut-star--empty" viewBox="0 0 20 20"><polygon points="10,1 12.9,7 19.5,7.6 14.5,12 16.2,18.5 10,15 3.8,18.5 5.5,12 0.5,7.6 7.1,7"/></svg>';}
  }
  return'<span class="ut-stars">'+h+'</span>';
}
var logo='<svg class="ut-card-logo" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><circle cx="10" cy="10" r="10" fill="#F5A623"/><text x="50%" y="55%" dominant-baseline="middle" text-anchor="middle" fill="#fff" font-size="11" font-weight="bold" font-family="Georgia,serif">U</text></svg>';
function init(){
  var els=document.querySelectorAll("[data-untappd-card-bid]");
  if(!els.length)return;
  var i,el,bid;
  for(i=0;i<els.length;i++){
    el=els[i];
    bid=el.getAttribute("data-untappd-card-bid");
    if(!bid)continue;
    (function(el,bid){
      fetch(P+"?bid="+bid)
        .then(function(r){return r.json();})
        .then(function(d){
          if(!d.items||!d.items.length)return;
          var item=d.items[0];
          var score=parseFloat(item.rating)||0;
          if(score>0){
            el.innerHTML=logo+stars(score)+'<span class="ut-card-score">'+score.toFixed(2)+'</span>';
          } else {
            el.style.display="none";
          }
        })
        .catch(function(){el.style.display="none";});
    })(el,bid);
  }
}
if(document.readyState==="loading"){document.addEventListener("DOMContentLoaded",init);}else{init();}
})();